import {
  getPageHeader,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  PageContainer,
  PageHeader,
  PageHeaderLeading,
  OnboardingSetupCard,
  getDashboardSection,
} from '@yeshuman/sdk'
import { User } from 'lucide-react'
import { PatientDashboardSections } from './components/patient-dashboard-sections'

export function PatientDashboard({ onStartConversation }: { onStartConversation?: (message: string) => void }) {
  return (
    <PageContainer>
      <OnboardingSetupCard className="mb-6" onAskAgent={onStartConversation} />
      <PageHeader
        leading={<PageHeaderLeading />}
        {...getPageHeader('/patient', 'Patient Dashboard', 'Track your health journey and return to healthy living')}
        icon={<User className="h-5 w-5" />}
      />

      <PatientDashboardSections onStartConversation={onStartConversation} />
    </PageContainer>
  )
}

export function PractitionerDashboard({ onStartConversation }: { onStartConversation?: (message: string) => void }) {
  return (
    <PageContainer>
      <OnboardingSetupCard className="mb-6" onAskAgent={onStartConversation} />
      <PageHeader
        leading={<PageHeaderLeading />}
        {...getPageHeader('/practitioner', 'Practitioner Dashboard', 'Support your patients on their health journey')}
        icon={<User className="h-5 w-5" />}
      />

      <div className="grid grid-cols-1 @2col:grid-cols-2 gap-4">
        <Card>
          <CardHeader>
            <CardTitle>What you can do now</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-sm">
              {(getDashboardSection('practitioner')?.capabilities ?? [
                'Use AI-powered conversation for basic assistance',
                'Navigate between different focus modes',
                'Manage conversation threads and search through your chat history',
                'View and manage memories that the AI has learned about you'
              ]).map((item: string, i: number) => (
                <li key={i}>• {item}</li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Coming soon</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {(getDashboardSection('practitioner')?.comingSoon ?? [
                'Patient management and profiles',
                'Consultation scheduling and management',
                'Health records review',
                'Treatment planning',
                'Patient communication tools'
              ]).map((item: string, i: number) => (
                <li key={i}>• {item}</li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    </PageContainer>
  )
}
